import { Component, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ViewRequestService } from '../view-request/view-request.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CreateNewRequestService } from '../manage-shipping/create-new-request/create-new-request.service';
import { ToastrService } from 'ngx-toastr';
import { MatCheckboxChange } from '@angular/material/checkbox/checkbox';
import * as S3 from 'aws-sdk/clients/s3';
import * as FileSaver from 'file-saver';
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import * as moment from 'moment';


@Component({
  selector: 'app-pre-production',
  templateUrl: './pre-production.component.html',
  styleUrls: ['./pre-production.component.scss']
})

export class PreProductionComponent {
  isScrapped: boolean = false;
  plantCode: string = '';
  userId: any;
  userName: any;
  viewRequestArray: any;
  requestNumber: string;
  formGroup: FormGroup;
  showLoader = true;
  isUpdating = false;
  spinner1 = 'preProdSpinner';
  isFormDisabled = false;
  
  accessKey: string;
  secretKey: string;
  sessionToken: string;
  filesList: any[] = [];
  filesNameList: string[] = [];
  attachedFile: any;
  fileContent: any;
  showAttachErrorMsg: boolean = false;
  showAttachDeleteBtn = false;
  deleteFileNames: any[] = [];
  showMatBadge = true;
  showAttachmentBadge = true;
  attachmentBadge = 0
  uploadedFiles:any;
  comments: string = '';
  originalComments: string = '';
  status: string = '';
  initialPreProdStatus: string = '';
  modalFilesOnlyList: File[] = [];
  preprodList:any = []
  preprodNameList:any = []
  requestStatus: string = '';
  @Output() closeDialog = new EventEmitter<boolean>();
  


  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;


  constructor(private _formBuilder: FormBuilder, private route: ActivatedRoute, private readonly toastrService: ToastrService,private viewRequestService: ViewRequestService, private spinner: NgxSpinnerService, private createNewRequestService: CreateNewRequestService){
     const routeParams = this.route.snapshot.paramMap;
     this.requestNumber = routeParams.get('reqNumber') || '';
  }

  ngOnInit(): void {
    this.spinner.show(this.spinner1); 
    let id_token = JSON.parse(localStorage.getItem('MSRS_IDTOKEN') || '""');
    let access_token = JSON.parse(localStorage.getItem('MSRS_ACCESSTOKEN') || '""');
    this.userId = id_token['Workday Id'];
    this.userName = id_token.GivenName + ' ' + id_token.Surname;
    this.plantCode = localStorage.getItem('plantCode') || '';
    const data = localStorage.getItem('preProductionFiles');
    if (data) {
      this.uploadedFiles = JSON.parse(data);
    }
    this.formGroup = this._formBuilder.group({
      preProductionStatus: ['',],
      scrapReturnDate: ['',],
    })

    this.viewRequest();
    this.getS3Info();
  }

  viewRequest() {
    this.viewRequestService.viewRequest(this.plantCode, this.requestNumber).subscribe(
      (response: any) => {
        this.viewRequestArray = response.payload[0];

        this.requestStatus = this.viewRequestArray.requeststatus;
        const nonEditableStatuses = ['Pending Compliance Validation', 'Compliance Hold', 'Pending Shipping', 'Submitted', 'Cancelled', 'Rejected'];

        if (nonEditableStatuses.includes(this.requestStatus)) {
          this.formGroup.get('preProductionStatus')?.disable();
        }
        this.status = this.viewRequestArray.preproductionstatus;
        const isPending = this.status === 'Pending';
        
        this.formGroup.get('preProductionStatus')?.setValue(this.status);
        
        const utcDate = new Date(this.viewRequestArray.scrapreturndate);
        this.formGroup.get('scrapReturnDate')?.setValue(
          new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate())
        );
        
        this.comments = 
          (this.viewRequestArray.preproductioncomments === null || 
          this.viewRequestArray.preproductioncomments === "null") 
          || (this.viewRequestArray.preproductioncomments === undefined ||
            this.viewRequestArray.preproductioncomments === "undefined"
          )
            ? ''
            : this.viewRequestArray.preproductioncomments;

        this.originalComments = this.comments;

        if (!isPending) {
          this.formGroup.disable(); 
          this.isFormDisabled = true; 
        } else {
          this.isFormDisabled = false;
        }

        this.scrapProof(); 

        this.spinner.hide(this.spinner1);
        this.showLoader = false;
      },
      error => {
        console.error('Error loading view request:', error);
        this.spinner.hide(this.spinner1);
        this.showLoader = false;
      }
    );
    this.getAttachments();
  }

  scrapProof() {
    const status = this.formGroup.get('preProductionStatus')?.value;
    this.isScrapped = status === 'Scrapped';
  }

 isUpdateDisabled(): boolean {
    if (this.isFormDisabled) return true;

    const status = this.formGroup.get('preProductionStatus')?.value;
    const statusDirty = this.formGroup.get('preProductionStatus')?.enabled && this.formGroup.get('preProductionStatus')?.dirty;
    const dateDirty = this.formGroup.get('scrapReturnDate')?.dirty;
    const commentChanged = this.comments !== this.originalComments;
    const attachRequire = status === 'Returned to Tradezone' || status === 'Scrapped';

    if (attachRequire && this.preprodNameList.length === 0) {
      return true;
    }

    if(!(statusDirty || dateDirty || commentChanged)){
      return true;
    }

    return false;
  }


  close() {
    this.closeDialog.emit(false);
  }

  updatePreProductionData() {
    const formValues = this.formGroup.value;
    const preProductionStatus = this.formGroup.get('preProductionStatus')?.value;

    const payload = {
      requestId: this.requestNumber,
      preProductionStatus: preProductionStatus,
      scrapReturnDate: formValues.scrapReturnDate? moment(formValues.scrapReturnDate).format('YYYY-MM-DD'): '',
      preProductionComments: this.comments
    };

    this.showLoader = true; 
    this.spinner.show(this.spinner1);

    const hideLoaderAfterDelay = () => {
      setTimeout(() => {
        this.spinner.hide(this.spinner1);
        this.showLoader = false;
      }, 5000);
      this.viewRequest();
    };

    this.viewRequestService.updatePreProduction(payload).subscribe(
      (response: any) => {
        console.log('Update successful:', response);
        this.attachFile();
        this.formGroup.markAsPristine();
        this.formGroup.markAsUntouched();
        this.comments = '';
        if(this.status != this.formGroup.get('preProductionStatus')?.value){
          console.log('this.line');
          switch (this.formGroup.get('preProductionStatus')?.value) {
            case 'Returned to Tradezone':
              this.insertActivityStream(this.requestNumber, 24, this.requestNumber + ' Pre-Production Part/Vehicle has Returned to Tradezone', '{' + this.userId + '}')
              break;
            case 'Scrapped':
              this.insertActivityStream(this.requestNumber, 23, this.requestNumber + ' Pre-Production Part/Vehicle has been Scrapped', '{' + this.userId + '}')
              break;
            case 'Pending':
              this.insertActivityStream(this.requestNumber, 25, this.requestNumber + ' Pre-Production Part/Vehicle is Pending', '{' + this.userId + '}')
              break;
          };
        }
        hideLoaderAfterDelay();
      },
      error => {
        console.error('Update failed:', error);
        this.viewRequest();
        this.comments = '';
        hideLoaderAfterDelay();
      }
    );
  } 

  insertActivityStream(requestId, eventId, eventComments, notificationUserId) {
    let streamObj = {
      "requestId": ["'" + requestId + "'"],
      "createdBy": this.userName,
      "userId": this.userId,
      "plantCode": this.plantCode,
      "eventId": eventId,
      "eventComments": eventComments,
      "notificationUserId": notificationUserId,
      "lastUpdatedBy": this.userName
    }
    this.createNewRequestService.addActivityStream(streamObj).subscribe((response: any) => {
    }, err => {
      this.toastrService.error('Unable to add activity stream', 'Failed');
    })
  }

  getS3Info() {
    this.createNewRequestService.getS3Info().subscribe(data => {
      if (data.payload[0] !== null) {
        const aws = data.payload[0];
        this.accessKey = aws.AccessKeyId;
        this.secretKey = aws.SecretAccessKey;
        this.sessionToken = aws.SessionToken;
      } else {
        this.toastrService.error('Data Storage Disconnected.');
      }
    }, err => {
      this.toastrService.error('Unable to get keys and token', 'Failed');
    });
  }

  handleFileInput(files: FileList , context: 'modal' | 'preprod') {
  this.showAttachErrorMsg = false;
  this.spinner.show();

  const allowedExtensions = ['.gif', '.jpe', '.jpg', '.jpeg', '.svg', '.pdf', '.doc', '.docx', '.pptx', '.txt', '.xlsx', '.msg', '.rar', '.csv', '.ppt', '.xls', '.png', '.tif'];

  for (let i = 0; i < files.length; i++) {
     const file :any = files.item(i);
      if (context == 'preprod') {
        file.attachpreprod = true;
      } else {
        file.attachpreprod = false;
      }
    if (!file) continue;
    const fileReader = new FileReader();
    const self = this;
    fileReader.onloadend = () => {
      const fileContent = fileReader.result as string;
      this.spinner.hide();

      if (fileContent.startsWith('MZ')) {
        console.warn('Executable file detected');
        this.attachedFile = '';
        alert('Please upload valid file! File format should be one of: ' + allowedExtensions.join(', '));
        return;
      }

      const fileName = file.name.toLowerCase();
      const isValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));

      if (!isValidExtension) {
        this.attachedFile = '';
        alert('Please upload valid file! File format should be one of: ' + allowedExtensions.join(', '));
        return;
      }

      if (file.size > 15 * 1024 * 1024) { // 15 MB
        this.showAttachErrorMsg = true;
        this.attachedFile = '';
        return;
      }
      self.filesList.push(file)
      if (context != 'preprod') {
        // self.filesList.push(file)
        self.filesNameList.push(file.name)
        self.modalFilesOnlyList.push(file);
      }
      if (context === 'preprod') {
        // self.filesList.push(file)
        self.preprodList.push(file);
        self.preprodNameList.push(file?.name)
      }
      self.filesList = [...self.filesList]
      self.filesNameList = [...self.filesNameList]
      self.attachedFile = ''
      if (context !== 'preprod') {
        self.modalFilesOnlyList = self.modalFilesOnlyList.filter(f =>
          self.filesList.some(fl => fl.name === f.name && fl.size === f.size)
        );
        self.attachmentBadge = self.modalFilesOnlyList.length;
      }
      console.log(self.filesList)
          
      // Store file info
      // this.filesList.push(file);
      // this.filesNameList.push(file.name);
      // this.filesList = [...this.filesList];
      // this.filesNameList = [...this.filesNameList];
      // this.attachedFile = '';
    };

    fileReader.readAsText(file);
    }
  }

  sanitizeFilename(fileName: string | undefined | null): string {
    if (!fileName || typeof fileName !== 'string') return '';

    return fileName
      .replace(/\s+/g, '_')     
      .replace(/\(/g, '_')      
      .replace(/\)/g, '_');
  }

  attachFile() {
    this.spinner.show()
    this.insertAttachments(["'"+this.requestNumber+"'"]);
  }

 insertAttachments(requestId: any) {
        this.getS3Info();
        let attachObj: any[] = [];
        const bucket = new S3({
          accessKeyId: this.accessKey,
          secretAccessKey: this.secretKey,
          sessionToken: this.sessionToken,
          region: 'us-west-2'
        });
        for (let i = 0; i < this.filesList.length; i++) {
          if(this.filesList[i].isSaved){
            continue;
          }
          const fileName= this.filesList[i].name || this.filesList[i].filename;
          // const fileName = file.replace(/[&\/\\#, +()$~%@'":*?<>{}]/g, '_');
          const params = {
            Bucket: 'nonprod-msrs-ui-fileupload',
            Key: requestId[0].replaceAll("'", '') + '/' + fileName,
            Body: this.filesList[i],
            ServerSideEncryption: 'AES256'
          };
          bucket.upload(params, (err, data) => {
            console.log(data, err);
            if (err) {
              console.error('There was an error uploading your file:', err);
              return;
            }
            console.log('Successfully uploaded file.', data);
          });
          const obj = {
            "requestId": requestId,
            "plantCode": this.plantCode,
            "fileName": fileName,
            "filePath": "nonprod-msrs-ui-fileupload.s3.us-west-2.amazonaws.com/" + requestId[0].replaceAll("'", "") + '/' + fileName,
            "isAdminFile": "N",
            "createdBy": this.userName,
            "lastUpdatedBy": this.userName,
            "attachpreprod" : (this.filesList[i].attachpreprod === true || this.filesList[i].attachpreprod === 'Y') ? "Y" : "N",
            "attachhazmat": "N",
            "uploadedFrom": "preprod"
          };
          attachObj.push(obj);
        }
        this.createNewRequestService.insertAttachments(attachObj).subscribe({
          next: (response: any) => {
            this.spinner.hide();
            console.log('Backend response:', response);
            this.getAttachments();
          },
          error: (err) => {
            this.spinner.hide();
            console.error('Attachment insert error:', err);
            this.toastrService.error('Unable to add attachment(s)', 'Failed');
          }
        });
  }
  
  getAttachments() {
  
    this.spinner.show();

    this.viewRequestService.getAttachment(this.requestNumber).subscribe({
      next: (response: any) => {
          this.filesList = [];
    this.filesNameList = [];
    this.preprodNameList=[];
        this.spinner.hide();

        const payload = response?.payload || [];

        if (!payload.length) return;

        payload.forEach(element => {
          element.isSaved = true;
          if (!element || !element.filename || element.attachpreprod === null || element.attachpreprod == 'N') return;
          console.log(element);

          const fileName = element.filename.toLowerCase();;

          // Exclude .exe and ensure it's a valid extension
          const isValidExtension = /\.(gif|jpe|jpg|jpeg|svg|pdf|docx?|pptx?|txt|xlsx?|msg|rar|csv|png|tif)$/.test(fileName);
          const isExecutable = fileName.endsWith('.exe');

          if (isValidExtension && !isExecutable) {
// 
            // this.preprodNameList.push(element);
            // this.preprodNameList = [...this.preprodNameList];
            this.filesList.push(element)
            if (element.isadminfile == 'N' && (element.attachpreprod == 'N' || element.attachpreprod == null)) {
              this.modalFilesOnlyList.push(element);
            }
          }
        });

        for (let i = 0; i < this.filesList.length; i++) {          
            if (this.filesList[i].isadminfile == 'N' && this.filesList[i].attachpreprod == 'Y' && this.filesList[i].uploadedfrom == 'create') {

              let fileName = this.filesList[i].filename;
              const ext = fileName.split('.').pop();

              // Match __number__ or _number_ pattern
              const match = fileName.match(/^_+(\d+)_+$/);
              if (match) {
                const num = match[1];
                // Remove the number pattern and replace underscores with spaces
                const base = fileName.replace(/^_+(\d+)(?=_+$)/, '').replace(/\.[^/.]+$/, "").replace(/_/g, " ").trim();
                fileName = `${base} (${num}).${ext}`;
              } else {
                // Just clean underscores if no number pattern
                fileName = fileName.replace(/_/g, " ");
              }
              this.filesList[i].sanitizefilename = this.filesList[i].filename
              this.filesList[i].filename= fileName
              this.filesNameList.push(this.filesList[i]);
              console.log("filelistttt", fileName);
            } else if (this.filesList[i].isadminfile == 'N' && this.filesList[i].attachpreprod == 'Y' && this.filesList[i].uploadedfrom == 'preprod') {

              let fileName = this.filesList[i].filename;
              const ext = fileName.split('.').pop();
              const match = fileName.match(/^_+(\d+)_+$/);
              if (match) {
                const num = match[1];
                // Remove the number pattern and replace underscores with spaces
                const base = fileName.replace(/^_+(\d+)(?=_+$)/, '').replace(/\.[^/.]+$/, "").replace(/_/g, " ").trim();
                fileName = `${base} (${num}).${ext}`;
              } else {
                // Just clean underscores if no number pattern
                fileName = fileName.replace(/_/g, " ");
              }
              this.filesList[i].sanitizefilename = this.filesList[i].filename
              this.filesList[i].filename= fileName
              this.preprodNameList.push(this.filesList[i]);
              console.log("preprodNameListfilelistttt", fileName);
            }

          

        }
      },
      error: (err) => {
        this.spinner.hide();
        this.toastrService.error('Unable to get Attachments', 'Failed');
      }
    });

    console.log('attachedpreprodNameListlist',this.preprodNameList);
  }

  
  attachmentSelect(event: MatCheckboxChange, name) {
    if (event.checked) {
      this.deleteFileNames.push(name);
    } else {
      const index = this.deleteFileNames.indexOf(name);
      if (index > -1) {
        this.deleteFileNames.splice(index, 1);
      }
    }

    this.showAttachDeleteBtn = this.deleteFileNames.length > 0;
  }  

  deleteAttachedFile() {
    this.spinner.show();

    const deletedFileNames = new Set(this.deleteFileNames); 
    const deletedFile: any[] = [];

    // Filter out files to be deleted
    this.preprodNameList = this.preprodNameList.filter(file => {
      const shouldDelete = deletedFileNames.has(file.filename);
      if (shouldDelete) {
        deletedFile.push(file);
      }
      return !shouldDelete;
    });

    // Update file name list as well
    this.preprodNameList = this.preprodNameList.filter(name => !deletedFileNames.has(name));

    console.log("this.preprodNameList",this.preprodNameList)

    // // Update attachment badge
    // const visibleAttachments = this.preprodNameList.filter(item => item.attachhazmat !== 'Y');
    // this.attachmentBadge = visibleAttachments.length;
    // this.showAttachmentBadge = this.attachmentBadge === 0;

    // Collect attachment IDs to delete from backend
    const deleteId = this.deleteFileNames
      .filter(file => file.attachmentid !== undefined)
      .map(file => file.attachmentid);

      console.log(deleteId)

    if (deleteId.length === 0) {
      this.spinner.hide();
      this.showAttachDeleteBtn = false;
      return;
    }

    const attachObj = { attachmentId: deleteId.join() };

    console.log('Deleting attachments:', attachObj);

    this.createNewRequestService.deleteAttachment(attachObj).subscribe({
      next: (response: any) => {
        console.log('Delete response:', response);
        this.spinner.hide();

        Swal.fire({
          title: 'Deleted!',
          text: 'Attachment deleted successfully',
          icon: 'success',
          confirmButtonColor: '#cc0000',
          confirmButtonText: 'Ok',
          allowOutsideClick: false,
          allowEscapeKey: false
        });

        $('#attachment').modal('hide');
      },
      error: (err) => {
        this.spinner.hide();
        console.error('Deletion failed:', err);
        this.toastrService.error('Unable to delete the attached file', 'Failed');
      }
    });

    this.showAttachDeleteBtn = false;
  }

  deSanitize(tempFileName) {
    return tempFileName.replace(/[&\/\\#, +()$~%@'":*?<>{}]/g, '_');
  }

  sanitize(t: string): string {
    let fileName = t;
    const ext = fileName.split('.').pop() || '';

    // Remove extension temporarily for processing
    const nameWithoutExt = fileName.replace(/\.[^/.]+$/, "");

    // New: Match patterns like _1_1756055348486 (number + timestamp)
    const timestampMatch = nameWithoutExt.match(/_{1,5}(\d{1,10})(?=_{1,5}\d{10,}$)/);

    if (timestampMatch) {
      const num = timestampMatch[1];

      // Remove the _number_timestamp suffix
      let base = nameWithoutExt.replace(/_{1,5}\d{1,10}(?=_{1,5}\d{10,}$)/, '');

      // Replace remaining underscores with space
      base = base.replace(/_/g, ' ').trim();

      fileName = `${base} (${num}).${ext}`;
    }
    else {
      // Existing logic
      const match = fileName.match(/^_+(\d+)_+$/);
      if (match) {
        const num = match[1];

        const base = fileName
          .replace(/^_+(\d+)(?=_+$)/, '')
          .replace(/\.[^/.]+$/, '')
          .replace(/_/g, ' ')
          .trim();

        fileName = `${base} (${num}).${ext}`;
      } else {
        // Just clean underscores if no number pattern
        fileName = fileName.replace(/_/g, ' ');
      }
    }

    return fileName;
  }

  downloadFile(i) {
    this.getS3Info();
      let folderName = i.filepath.split('/');
      const bucket = new S3(
          {
            accessKeyId: this.accessKey,
            secretAccessKey: this.secretKey,
            sessionToken: this.sessionToken,
            region: 'us-west-2'
          }
        );
        const params = {
          Bucket: 'nonprod-msrs-ui-fileupload',
          Key: folderName[1] + '/' + i.sanitizefilename,
        };
        console.log('download', params);
        bucket.getObject(params, (err: any, data: any) => {
          if (err) {
            this.toastrService.error('Unable to download', 'Failed')
          } else {
            const file: Blob = new Blob([data.Body], {
              type: ''
            });
            FileSaver.saveAs(file, this.sanitize(i.sanitizefilename));
          }
        })
      }  

}